import * as yup from "yup";
import dayjs from "dayjs";

export const effectiveFromSchema = yup.date()
    .required("Effective From is required");

export const effectiveToSchema = yup.date()
    .required("Effective To is required")
    .when('effectiveFrom', ([effectiveFrom], schema) => {
        return effectiveFrom ? schema.min(effectiveFrom, "Effective To cannot be before Effective From") : schema; 
    });

export const bandedSchema = yup.object({
    effectiveFrom: effectiveFromSchema,
    effectiveTo: effectiveToSchema
});

export const newBandDefaultValues = {
    effectiveFrom: dayjs().startOf('day').toDate(),
    effectiveTo: new Date(9999, 11, 31)
};
